export enum JobType
{
    new_collection="new_collection",
    scope_rebuild="scope_rebuild",
    data_source="data_source",
    analyze="analyze",
    preview="preview"
}